// components/Celebration/celebrationThemes.js
export const celebrationThemes = {
  default: {
    accent: "#3b82f6",
    confettiColors: ["#3b82f6", "#10b981", "#f43f5e", "#fbbf24"],
  },

  meeting_personality: {
    accent: "#00b3a4",
    confettiColors: ["#00b3a4", "#72e5d3", "#fff176", "#ff6f61"],
  },

  stakeholders: {
    accent: "#ed254e",
    confettiColors: ["#ed254e", "#f9dc5c", "#5eb1bf"],
  },

  identity: {
    accent: "#5eb1bf",
    confettiColors: ["#5eb1bf", "#ed254e", "#f9dc5c"],
  },
};
